<template>
  <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
    <div class="avatar-wrapper">
      <div class="icon-user">
        <img src="~@/assets/image/user.svg" class="user-avatar">
      </div>
      <!-- <i class="el-icon-user" /> -->
    </div>
    <el-dropdown-menu slot="dropdown">
      <router-link to="/profile/index">
        <el-dropdown-item>个人中心</el-dropdown-item>
      </router-link>
      <!-- <el-dropdown-item>
              <span @click="setting = true">布局设置</span>
            </el-dropdown-item> -->
      <el-dropdown-item divided @click.native="logout">
        <span>退出登录</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import { logOut } from '@/api/login'

export default {
  name: 'UserCenter',
  data() {
    return {

    }
  },
  methods: {
    logout() {
      this.$confirm('确定要退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        logOut().then((res) => {
          this.$store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.right-menu-item {
  // display: inline-block;
  padding: 0 8px;
  // height: 100%;
  font-size: 27px;
  color: white;
  // vertical-align: text-bottom;

  &.hover-effect {
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .icon-user {
    padding: 12px;
    width: 40px;
    height: 40px;
    display: flex;
    background: white;
    align-items: center;
    justify-content: center;
    border-radius: 22px;
    border: 4px solid #1386fbb8;
  }

}
</style>
